import React, { useState } from 'react';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField, CircularProgress } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { selectCreateNoteOpened, selectCreateNoteError, selectCreatingNewNote } from '../state';
import { red } from '@material-ui/core/colors';

export default function CreateNote(
  {onClose, onSave}: {onClose: any, onSave: any,}
) {
  const createNoteOpened = useSelector(selectCreateNoteOpened);
  const loading = useSelector(selectCreatingNewNote);
  const error = useSelector(selectCreateNoteError);
  const [value, setValue] = useState<string>('');

  if (!createNoteOpened && value) {
    setValue('');
  }

  const close = () => onClose();
  const save = () => onSave(value);

  return (
    <Dialog
      open={createNoteOpened}
      onClose={close}
      aria-labelledby="create-note"
    >
      <DialogTitle id="create-note">{"Create note"}</DialogTitle>
      <DialogContent>
        {error && (<div style={{color: red.A400, marginBottom: 28}}>
          {error}
        </div>)}
        <TextField
          value={value}
          style={{ width: 300 }}
          onChange={(event) => setValue(event.target.value)}
          multiline
          rows={2}
          rowsMax={Infinity}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={close}>
          Cancel
        </Button>
        <Button onClick={save} variant="contained" color="secondary"
          autoFocus disabled={!value || loading}>
          {loading && <CircularProgress style={{marginRight: 8}} size={24} />}
          Save
        </Button>
      </DialogActions>
    </Dialog>
  )
}